// src/components/AdminRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Box, CircularProgress } from '@mui/material';
import { fetchUserInfo } from '../hooks/hooks';

const AdminRoute = ({ children }) => {
  const userData = JSON.parse(localStorage.getItem('userData') || '{}');
  const cachedIsAdmin = !!(userData?.user?.is_staff || userData?.user?.is_superuser);

  const { data, isLoading } = useQuery({
    queryKey: ['currentUserRole'],
    queryFn: fetchUserInfo,
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });

  if (isLoading && !cachedIsAdmin) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress sx={{ color: '#0BA480' }} />
      </Box>
    );
  }

  const isAdmin = data ? !!(data.is_staff || data.is_superuser) : cachedIsAdmin;

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default AdminRoute;
